import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { useQRBuilder } from '../hooks/useQRBuilder';
import { DotsPanel } from './DotsPanel';
import { EyesPanel } from './EyesPanel';
import { ColorsPanel } from './ColorsPanel';
import { FramePanel } from './FramePanel';
import { LogoPanel } from './LogoPanel';
import { PreviewPanel } from './PreviewPanel';
import { ExportPanel } from './ExportPanel';
export const QRBuilder = () => {
    const { url, setUrl, settings, update, exportSize, setExportSize, ready, previewRef, previewSize, setPreviewSize, downloadPng, downloadSvg, } = useQRBuilder();
    return (<div className="flex flex-col xl:flex-row gap-6 w-full min-h-0">
            <div className="flex-1 min-w-0">
                <Tabs defaultValue="dots" className="w-full">
                    <TabsList className="w-full justify-start overflow-x-auto">
                        <TabsTrigger value="dots">Dots</TabsTrigger>
                        <TabsTrigger value="eyes">Eyes</TabsTrigger>
                        <TabsTrigger value="colors">Colors</TabsTrigger>
                        <TabsTrigger value="frame">Frame</TabsTrigger>
                        <TabsTrigger value="logo">Logo</TabsTrigger>
                        <TabsTrigger value="export">Export</TabsTrigger>
                    </TabsList>

                    <Separator className="my-3"/>

                    <ScrollArea className="h-[calc(100vh-280px)] pr-2">
                        <TabsContent value="dots" className="mt-0 px-1">
                            <DotsPanel settings={settings} update={update}/>
                        </TabsContent>

                        <TabsContent value="eyes" className="mt-0 px-1">
                            <EyesPanel settings={settings} update={update}/>
                        </TabsContent>

                        <TabsContent value="colors" className="mt-0 px-1">
                            <ColorsPanel settings={settings} update={update}/>
                        </TabsContent>

                        <TabsContent value="frame" className="mt-0 px-1">
                            <FramePanel settings={settings} update={update}/>
                        </TabsContent>

                        <TabsContent value="logo" className="mt-0 px-1">
                            <LogoPanel settings={settings} update={update}/>
                        </TabsContent>

                        <TabsContent value="export" className="mt-0 px-1">
                            <ExportPanel ready={ready} exportSize={exportSize} onExportSizeChange={setExportSize} onDownloadPng={downloadPng} onDownloadSvg={downloadSvg}/>
                        </TabsContent>
                    </ScrollArea>
                </Tabs>
            </div>

            <div className="w-full xl:w-80 shrink-0">
                <PreviewPanel url={url} onUrlChange={setUrl} ready={ready} canvasRef={previewRef} previewSize={previewSize} onPreviewSizeChange={setPreviewSize}/>
            </div>
        </div>);
};
QRBuilder.displayName = 'QRBuilder';
